import React, {MouseEvent, useCallback, useMemo} from "react";
import {Link} from "react-router-dom";
import clsx from "clsx";
import {useSiren} from "./SirenContext";

type NavButtonProps = {
    active?: boolean;
    text: string;
    icon?: React.ReactNode,
    to: string;
    disabled?: boolean;
    show?: boolean;
}

export function NavButton(
    {
        active = false,
        text,
        icon = null,
        to,
        disabled = false,
        show = false,
    }: NavButtonProps) {

    const {clientID, scopeParam} = useSiren()

    const containerClass = useMemo(() => {
        return clsx(
            "h-9 pl-3 pr-4 rounded-md flex items-center gap-2 whitespace-nowrap",
            {
                "bg-light-light-grey text-grey opacity-60": !active || disabled,
            },
            {
                "bg-blue text-white": active && !disabled,
            }
        )

    }, [active, disabled])

    const handleClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
        if(active || disabled) {
            e.preventDefault();
        }
    },[active, disabled])

    const link = useMemo(() => {
        const url = new URL(to, `${window.location.protocol}//${window.location.host}`)
        if(clientID) {
            url.searchParams.set("clientID", clientID)
        }
        if(scopeParam) {
            url.searchParams.set("scope", scopeParam)
        }
        return url.toString()
    }, [to, clientID, scopeParam])

    if(!show){
        return null
    }

    return (
        <Link to={link} className={containerClass} onClick={handleClick}>
            {icon && <span className="text-[1.1rem] leading-none">{icon}</span>}
            <span className="font-semibold text-sm">{text}</span>
        </Link>
    )

}